// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/style.css
// module id = ./src/style.css
// module chunks = 1